/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import styled from "styled-components";
import { WasteIndicator } from "~/components/WasteIndicator";
import { useCurrency } from "~/hooks";
import { formatMoney, Maybe } from "~/tools";

type WrapperProps = {
  inline: boolean;
};

const Wrapper = styled.div<WrapperProps>`
  position: relative;
  display: ${({ inline }) => (inline ? "inline-flex" : "flex")};
  justify-content: space-between;
  align-items: center;
  padding-right: 0.5rem;

  & > div {
    display: flex;
    margin-top: -2px;
  }

  & > span {
    margin-right: 1rem;
  }
`;

export const DEFAULT_SUGGESTION =
  "Right-size or shutdown underutilized virtual machines";

type Props = {
  tooltip?: boolean;
  value?: number | string | null;
  inline?: boolean;
  isWaste?: boolean;
  reason?: string;
  moneyFormatter?: (value: Maybe<number | string>, currency: string) => string;
};

export function CostCell({
  value = 0,
  inline = false,
  isWaste = false,
  reason,
  moneyFormatter = formatMoney,
}: Props) {
  const { currency } = useCurrency();
  const wasteReason = isWaste ? reason : DEFAULT_SUGGESTION;
  const formattedValue = moneyFormatter(value, currency);

  return (
    <Wrapper inline={inline}>
      <span>{formattedValue}</span>
      <When condition={isWaste}>
        <WasteIndicator reason={wasteReason} />
      </When>
    </Wrapper>
  );
}
